import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { SERVICE_REQUEST_TYPES, ServiceRequestType } from "@/types/staffing/serviceRequest";
import { cn } from "@/lib/utils";
import { SectionHeader, FieldRow, FieldLabel, ErrorMsg } from "./FormPrimitives";

interface ServiceTypeSectionProps {
  serviceType: ServiceRequestType | "";
  onServiceTypeChange: (val: string) => void;
  error?: string;
  disabled: boolean;
}

export function ServiceTypeSection({
  serviceType,
  onServiceTypeChange,
  error,
  disabled,
}: ServiceTypeSectionProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-4 shadow-sm">
      <SectionHeader step={1} label="Request Type" />
      <FieldRow>
        <FieldLabel htmlFor="service-type" required>
          Service Type
        </FieldLabel>
        <Select value={serviceType} onValueChange={onServiceTypeChange} disabled={disabled}>
          <SelectTrigger
            id="service-type"
            className={cn(error && "border-destructive")}
          >
            <SelectValue placeholder="Select a request type…" />
          </SelectTrigger>
          <SelectContent>
            {SERVICE_REQUEST_TYPES.map((t) => (
              <SelectItem key={t} value={t}>
                {t}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <ErrorMsg msg={error} />
      </FieldRow>
    </div>
  );
}
